module.exports = __webpack_public_path__ + "static/cad-designs3-b8287912c76cda27b8cdd1371cad666b.png";